import $ from 'jquery';
import React from 'react';

import * as analytics from 'analytics/Analytics';

class Carousel {
  $el: JQuery;
  offset: number;
  total: number;
  interval?: NodeJS.Timeout;
  intervalTimeout: number;
  $indicator: JQuery;

  constructor(el: HTMLElement, intervalTimeout: number) {
    this.resetInterval = this.resetInterval.bind(this);
    this.$el = $(el);
    this.offset = 0;
    this.total = this.getChildren().length;
    this.intervalTimeout = intervalTimeout;
    this.resetInterval();
    this.$indicator = $('<div class="carouselIndicator u-pointer"></div>');
    for (let count = 0, end = this.total; count < end; count++) {
      this.$indicator.append(
        $('<div></div>')
          .toggleClass('active', count === 0)
          .click((e) => {
            const targetIndex = $(e.target).index();
            this.rotate(targetIndex);
            this.resetInterval();
          })
      );
    }
    this.$el.append(this.$indicator);
  }

  getChildren(): JQuery {
    return this.$el.find('.land-carouselWrapper').children();
  }

  resetInterval(): void {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(this.rotate.bind(this), this.intervalTimeout);
  }

  rotate(offset: number): void {
    this.offset = offset != null ? offset : (this.offset + 1) % this.total;
    this.getChildren()
      .eq(0)
      .css({marginLeft: `${this.offset * -100}%`});
    this.$indicator.children().each((i, el) => {
      $(el).toggleClass('active', i === this.offset);
    });
  }

  stop(): void {
    clearInterval(this.interval);
    this.$indicator.remove();
  }
}

class ScrollTrigger {
  $els: JQuery;

  constructor() {
    this.scrollHandler = this.scrollHandler.bind(this);
    this.$els = $(document).find('.scrollTrigger');
    // eslint-disable-next-line @typescript-eslint/unbound-method
    $(window).on('scroll.scrollTrigger', this.scrollHandler);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    $(window).on('resize.scrollTrigger', this.scrollHandler);
    this.$els.addClass('scrollHidden');
    this.scrollHandler();
  }

  scrollHandler(): void {
    const scrollTop = $(document).scrollTop();
    const lower = scrollTop + $(window).height() - 100;
    this.$els.each(function () {
      // @ts-expect-error type of `this` cannot be inferred. in this case it is a member of $els
      if (!$(this).hasClass('scrollHidden')) {
        return;
      }
      // @ts-expect-error type of `this` cannot be inferred. in this case it is a member of $els
      if ($(this).offset().top > lower) {
        return;
      }
      // @ts-expect-error type of `this` cannot be inferred. in this case it is a member of $els
      $(this).removeClass('scrollHidden');
    });
  }

  stop(): void {
    $(window).off('.scrollTrigger');
  }
}

interface LandingViewEnhancementsProps {
  carouselInterval: number;
}

export default class LandingViewEnhancements extends React.Component<LandingViewEnhancementsProps> {
  static defaultProps = {carouselInterval: 5000};

  scrollTrigger!: ScrollTrigger;
  carousels!: Array<Carousel>;

  override componentDidMount(): void {
    this.scrollTrigger = new ScrollTrigger();
    const {carouselInterval} = this.props;
    // @ts-expect-error our JQuery types are wrong here, and this does return back Carousels instead of JQuery
    this.carousels = $('.land-carousel').map(function () {
      // @ts-expect-error type of `this` cannot be inferred. in this case it is a .land-carousel element
      return new Carousel(this, carouselInterval);
    });
    // Demo link always opens new tab so we do not need to worry about the browser leaving the page and the
    // XHR getting lost (see discussion in D2504)
    $('.requestDemoLink').click(() => {
      analytics.track('homepage', 'clicked_request_demo_link');
    });
  }

  override componentWillUnmount(): void {
    this._stopCarousels();
    this.scrollTrigger.stop();
  }

  _stopCarousels(): void {
    this.carousels.forEach((carousel) => {
      carousel.stop();
    });
  }

  override render(): null {
    return null;
  }
}
